<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="KDDI GPU Cloud VNコネクト再実行"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col>
                <span
                  >再実行が必要なVNコネクトが存在します。再実行を行ってください。</span
                ><br />
                <span>再実行が完了するまでVNコネクトの操作はできません。</span>
              </v-col>
            </v-row>
            <app-table
              primary-key="cloudVnConnectAct.wnumber"
              :fields="vnConnects.fields"
              :items="retryList ? [retryList] : []"
              :per-page="-1"
              :tr-class="() => undefined"
            >
              <template #cell(wnumber)="{ item }">
                {{ item.cloudVnConnectAct.wnumber }}<br />{{
                  item.cloudVnConnectSby.wnumber
                }}
              </template>
              <template #cell(vnConnectName)="{ item }">
                {{ item.cloudVnConnectAct.vnConnectName }}<br />{{
                  item.cloudVnConnectSby.vnConnectName
                }}
              </template>
              <template #cell(mNumber)="{ item }">
                {{ item.cloudVnConnectCommon.mNumber }}
              </template>
              <template #cell(vpnVnCode)="{ item }">
                <template
                  v-if="item.cloudVnConnectCommon.vpnVnCode.charAt(0) !== 'B'"
                >
                  {{
                    `${item.cloudVnConnectCommon.vpnVnCode}(${item.cloudVnConnectCommon.vnType})`
                  }}
                </template>
                <template v-else>
                  {{ item.cloudVnConnectCommon.vpnVnCode }}
                </template>
              </template>
              <template #cell(bandwidth)="{ item }">
                {{ item.cloudVnConnectCommon.bandwidthType }}({{
                  $filter.bandwidthTo(item.cloudVnConnectCommon.bandwidth)
                }})
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="vnConnectRetry(retryList!.cloudVnConnectAct.wnumber)"
              variant="flat"
              color="primary"
              >再実行</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >キャンセル</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { CloudVnGpuList } from "@/apis/CloudVnGpuApi";
import type { AppTableHeader } from "@/components/AppTable.vue";

export default defineComponent({
  name: "MultiCloudGpuRetry",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    vnConnectList: {
      type: Object as PropType<CloudVnGpuList>,
      required: true,
      default: undefined,
    },
    cloudVnGpuKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      vnConnects: {
        fields: [
          {
            key: "wnumber",
            title: "VNコネクト番号(Act/Sby)",
            width: "150px",
          },
          {
            key: "vnConnectName",
            title: "VNコネクト名(Act/Sby)",
            width: "140px",
          },
          {
            key: "mNumber",
            title: "KDDI GPU Cloudご契約番号",
            width: "190px",
          },
          {
            key: "vpnVnCode",
            title: "接続先VPN/VNコード",
            width: "185px",
          },
          {
            key: "bandwidth",
            title: "品目",
            width: "140px",
          },
        ] as AppTableHeader<CloudVnGpuList>[],
        selected: [] as CloudVnGpuList["cloudVnConnectsList"],
      },
      isLoaded: false,
    };
  },
  computed: {
    /** 再実行対象のVNコネクト（仕様上1件のみ） */
    retryList(): CloudVnGpuList["cloudVnConnectsList"][0] | undefined {
      return this.vnConnectList!.cloudVnConnectsList.find(
        (item) =>
          item.cloudVnConnectCommon.provStatus === "RETRYABLE" ||
          item.cloudVnConnectCommon.provStatus === "DELETE_RETRYABLE" ||
          item.cloudVnConnectCommon.provStatus === "CREATE_FAILED"
      );
    },
  },
  async mounted() {
    this.isLoaded = true;
  },
  methods: {
    /** VNコネクト再実行 */
    async vnConnectRetry(wnumber: string) {
      await this.$confirm(`VNコネクト再実行を行います。よろしいですか？`);
      await this.$api.cloudVnGpu.cloudVnGpuRetry(this.cloudLineSeq, wnumber, {
        cloudVnGpuKeyId: this.cloudVnGpuKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
